var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from "module/main/util";
import { buttonVariantClass } from "./utils";
export var Button = function (_a) {
    var className = _a.className, _b = _a.variant, variant = _b === void 0 ? "primary" : _b, children = _a.children, props = __rest(_a, ["className", "variant", "children"]);
    return (_jsx("button", __assign({ className: cx("inline-flex h-10 items-center justify-center rounded-lg border px-5 text-sm font-bold transition disabled:cursor-not-allowed disabled:opacity-60", buttonVariantClass[variant], className) }, props, { children: children })));
};
